module.exports = __webpack_public_path__ + "static/img/SS.18b8bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/SS.png
// module id = RtnS
// module chunks = 0